<template>
  <div>
      <v-container>

          <div class="mx-5">
              <v-row class="mt-3">
        <v-col cols="12">
            <v-card>
                <v-card-title style="color:#48c074">
                  All Notifications
                </v-card-title>
                <v-data-table
                    :headers="transHeaders"
                    :items="Notifications"
                    no-data-text='You currently do not have any notifications'
                    >
                    <template v-slot:item.status="{ item }">
                        <span class="black--text">{{item.status}}</span>
                    </template>
                    <template v-slot:item.desc="{ item }">
                        <span class="black--text">{{item.description}}</span>
                    </template>
                    <template v-slot:item.type="{ item }">
                        <span class="black--text">{{item.paymentType}}</span>
                    </template>
                    <template v-slot:item.date="{ item }">
                        <span class="black--text">{{item.datePerformed}}</span>
                    </template>
                    <template v-slot:item.amount="{ item }">
                        
                        <span class="black--text">&#8358;{{item.amount}}</span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn text  @click="viewUser(item._id)" style="border: 1px #48c074 solid; color:#48c074" class="text-none" small>View</v-btn>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
      </v-row>
          </div>

     </v-container>
  </div>
</template>



<script>
export default {
    data(){
        return{
         transHeaders: [
            {
                text: 'Subject',
                align: 'start',
                sortable: false,
                value: 'subject',
            },
            { text: 'Body', value: 'body' },
            { text: 'Date Sent', value: 'date_sent' },           
            ] ,
        }
    },
    methods:{

    },
    computed:{
         Notifications(){
              return this.$store.state.notifications.notifications        
        },
    },
    created(){
          this.$store.dispatch("GetNotifications")
      .then(()=>{ 
      })
      .catch(()=>{
      });
    }
}
</script>

<style scoped>

</style>